import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function GuaranteeSection() {
  return <section id="comprar" className="py-24 px-4 bg-[#0a0e1a] relative overflow-hidden" data-id="element-22">
      {/* Background glow for guarantee */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-23" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-navy-800/80 border border-amber-500/20 rounded-3xl p-8 sm:p-12 text-center shadow-[0_0_40px_rgba(245,158,11,0.05)]" data-id="element-25">
          <div className="w-20 h-20 mx-auto bg-navy-900 border border-amber-500/30 rounded-2xl flex items-center justify-center text-amber-400 mb-8 shadow-[0_0_20px_rgba(245,158,11,0.15)]" data-id="element-26">
            <ShieldCheckIcon size={40} data-id="element-27" />
          </div>

          <h2 className="font-heading text-2xl sm:text-3xl text-white mb-6" data-id="element-28">
            Garantía de "Sueño Profundo o te devuelvo tus{' '}
            <span className="text-amber-400" data-id="element-29">$6.36</span>"
          </h2>

          <p className="text-slate-300 text-lg leading-relaxed mb-10" data-id="element-30">
            Si aplicas el protocolo por una sola noche y no sientes que tu mente
            se apaga más rápido y despiertas con más claridad, quédate con el
            PDF y envíame un email.{' '}
            <span className="text-white font-medium" data-id="element-31">
              Te devolveré cada centavo. Sin preguntas.
            </span>
          </p>

          <CTAButton text="Sí, Quiero Dormir Profundamente" className="w-full sm:w-auto" onClick={() => {
          trackAddToCart();
          window.open('https://novadigitalventures.com/cart/42535353811015:1', '_blank');
        }} data-id="element-32" />

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-slate-500" data-id="element-33">
            <ShieldCheckIcon size={16} data-id="element-34" />
            <span data-id="element-35">Pago 100% seguro y encriptado</span>
          </div>
        </motion.div>
      </div>
    </section>;
}